import React from 'react';
import clsx from 'clsx';

import { Badge } from '@/shared/Badge';
import { I18nLink } from '@/lib/components/I18nLink';

import { ArticleItemProps } from './types';
import styles from './ArticleItem.module.scss';

export function ArticleItem({ article, type, showBadge = true, onClick, className }: ArticleItemProps) {
  const itemClasses = clsx(styles.articleItem, className);

  return (
    <I18nLink href={`/helpdesk/${article.type || type}/${article.slug}`} className={itemClasses} onClick={onClick}>
      <svg
        className={styles.icon}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path d="M17.1583 5.225V18.75H2.84167V1.25H13.1833L17.1583 5.225Z" stroke="#44B58F" strokeWidth="1.5" strokeMiterlimit="10" />
        <path d="M6 10H14" stroke="#44B58F" strokeWidth="1.5" strokeMiterlimit="10" />
        <path d="M6 14H14" stroke="#44B58F" strokeWidth="1.5" strokeMiterlimit="10" />
        <path d="M17.1584 5.225V6.025H12.3834V1.25H13.1834L17.1584 5.225Z" stroke="#44B58F" strokeWidth="1.5" strokeMiterlimit="10" />
      </svg>
      <span className={styles.articleText}>
        <span className={styles.articleTitle}>{article.title}</span>
        {showBadge && article.badges && <Badge badge={article.badges} />}
      </span>
    </I18nLink>
  );
}
